<template>
  <div class="advertise-list">
    <up-dialog v-model="refuse.visible" size="tiny" title="审核被拒原因：">
      <p class="panel-content__refuse" v-for="(item, index) in refuse.reason" :key="index">{{ item }}</p>
      <img v-if="refuse.image" :src="refuse.image">
      <up-button slot="footer" @click="refuse.visible = false">确定</up-button>
    </up-dialog>
    <panel-head title="广告投放" subtitle="AD SERVING" :export-url="exportUrl"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">
        广告管理
        <up-button class="has-icon fr" @click="operateAd('add')" v-if="showAdd">
          <i>+&nbsp;</i>新增广告
        </up-button>
      </h3>
      <div class="panel-content__select-list">
        <up-select class="fl mr5 is-small" :data="selectList" v-model="key" @up:select:change="value = ''"></up-select>
        <up-select v-if="['status', 'ad_from'].includes(key)" class="fl mr5 is-small" :data="key === 'status' ? statuses : adFroms" v-model="value"></up-select>
        <up-input v-else class="fl mr5" v-model="value"></up-input>
        <up-button @click="searchAd">查询</up-button>
        <div class="fr mr20">
          <up-button type="primary" @click="batchStartAndStopAd(selectedIds, true, true)" :loading="starting">批量开启</up-button>
          <up-button class="is-warning" type="primary" @click="batchStartAndStopAd(selectedIds, true, false)" :loading="stopping">批量暂停</up-button>
        </div>
      </div>
      <div class="panel-content__nav-list">
        <span class="panel-content__nav-item" v-for="item in navs" :key="item.name" :class="{ 'is-active': item.value === currentNav }" @click="switchNav(item)">{{item.name}}{{item.total}}条</span>
      </div>
      <div class="panel-content__table-wrap">
        <up-table class="panel-content__table" selection pagination :page="page" align="center" show-overflow-tooltip
                  :width-columns="{ ad_name: 240, account_name: 120, name: 200, user_type: 120, order_name: 240, time: 200, ad_from: 100, created_at: 160, place_attribute: 120, updated_at: 160, status_msg: 100 }"
                  :slot-contents="['ad_name', 'order_name', 'verify', 'status_msg']"
                  @cell-click="handleCellClick"
                  @up:selection-change="handleSelectChange"
                  @up:current-change="getAdvertises"
                  @up:size-change="getAdvertises">
          <template slot="ad_name:content" slot-scope="{ row }">
            <router-link class="panel-content__table-link" :to="{ name: 'advertiseOpr', params: { adType: adType, type: 'view', id: row.id }, query: { oid: row.order_id } }"
            >{{row.ad_name}}</router-link>
          </template>
          <template slot="order_name:content" slot-scope="{ row }">
             <router-link class="panel-content__table-link" :to="{ path: '/orderList/nofilter', query: { name: row.order_name, value: 'order_name' } }"
        >{{row.order_name}}</router-link>
          </template>
          <template slot="verify:content" slot-scope="{ row, column }">
            <span :class="{ 'is-refuse': row.verify === '已拒绝'  }">{{row[column.property]}}</span>
          </template>
          <template slot="status_msg:content" slot-scope="{ row }">
            <div class="panel-content__table-status-box">
              <span class="panel-content__table-status" :class="{'is-active' : row.status_msg === '已启用'}"></span>
              <span>{{ row.status_msg }}</span>
            </div>
          </template>
          <template slot="up:operate">
            <up-table-column width="54" fixed="right" label="开关">
              <template slot-scope="{ row, $index }">
                <up-switch v-if="row.status !== 2" :value="row.status === 1" @change="startAndStopAd(row, $index)"></up-switch>
              </template>
            </up-table-column>
            <up-table-column width="204" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <!--<template v-if="row.status !== '已停止' && user.id_tag !== 9">
                  <up-tooltip effect="dark" placement="top" :content="stopStatuses.includes(row.status) ? '启动' : '暂停'">
                    <span>
                      <i v-show="!loadings[$index]" class="panel-content__table-icon iconfont"
                      :class="stopStatuses.includes(row.status) ? 'icon-play' : 'icon-pause'" @click="startAndStopAd(row, $index)"></i>
                      <i v-show="loadings[$index]" class="panel-content__table-icon el-icon el-icon-loading"></i>
                    </span>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" content="停止">
                    <i class="panel-content__table-icon iconfont icon-stop" @click="removeAd(row)"></i>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" content="编辑" v-if="row.status !== '投放中' && row.time_state === 0">
                    <i class="panel-content__table-icon iconfont icon-edit" @click="operateAd('edit', row)"></i>
                  </up-tooltip>
                </template>
                <up-tooltip effect="dark" placement="top" content="查看">
                  <i class="panel-content__table-icon iconfont icon-look" @click="operateAd('view', row)"></i>
                </up-tooltip>-->
                <div>
                 <up-button v-if="row.status === 0 && row.time_state === 0" class="is-edit" size="small" type="primary" @click="operateAd('edit', row)">编辑</up-button>
                  <up-button class="is-view" size="small" type="primary" @click="operateAd('view', row)">查看</up-button>
                  <!--<up-button class="is-mini" size="small" type="primary" @click="startAndStopAd(row, $index)" :loading="loadings[$index]">开始</up-button>-->
                  <up-button v-if="row.status !== 2" class="is-remove" size="small" type="primary" @click="removeAd(row)">停止</up-button>
                  <up-button class="is-mini" size="small" type="primary" @click="operateAd('copy', row)">复制</up-button>
                </div>
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PanelHead } from '@/global/components'
import { get, capturedGet, capturedPost, capturedRemove } from '@/manager/http'

export default {
  name: 'advertise-list',
  components: { PanelHead },
  data () {
    // this.stopStatuses = ['已暂停', '排期已过', '预算不足', '余额不足', '未在投放时间(已暂停)']
    this.stopStatuses = ['排期已过']
    this.verifyResults = [
      { name: '通过', value: '1' },
      { name: '拒绝', value: '2' }
    ]
    this.verifyReasons = [
      { name: '图片违规', value: '1' },
      { name: '落地页与产品不符', value: '2' },
      { name: '广告标题违规', value: '3' },
      { name: '自定义', value: '0' }
    ]

    return {
      platform: 'admin',
      adType: 'radio',
      key: '',
      value: '',
      selectList: [],
      navs: [],
      currentNav: 'all',
      adFroms: [],
      verifies: [],
      statuses: [],
      page: new this.$page(),
      loadings: [],
      selectedIds: [],
      starting: false,
      stopping: false,
      refuse: {
        visible: false,
        reason: [],
        image: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user',
      globalAdType: 'login/adType'
    }),
    exportUrl () {
      return ''
    },
    showAdd () {
      return this.user && this.user.id_tag !== 9
    }
  },
  methods: {
    async getSearchList () {
      const [, { data: { arr1: selectList, arr2: navs } }] = await capturedGet(`/${this.platform}/ads/ad/selectlist`)
      this.selectList = selectList
      this.navs = [{ name: '全部广告', value: 'all' }].concat(navs)

      await this.getVerifyList()
    },
    async getVerifyList () {
      const [, { data }] = await capturedGet(`/${this.platform}/ads/verify-list`, this.getRequestParams())
      this.navs = this.navs.map((item) => { /* eslint-disable eqeqeq */
        item.total = data.find(v => v.verify == item.value).total
        return item
      })
    },
    switchNav ({ value }) {
      if (this.currentNav === value) return
      this.currentNav = value
      this.page.resetData()
      this.getAdvertises()
    },
    getRequestParams ({ key = this.key, value = this.value, verify = this.currentNav, export: isExport = false } = {}) {
      const { currentPage, pageSize } = this.page
      let params = {}

      if (key && value) params[key] = value
      if (verify !== 'all') params.verify = verify
      if (isExport) {
        params.is_export = 1
      } else {
        params = {
          ...params,
          per_page: pageSize,
          page: currentPage
        }
      }

      return params
    },
    async getAdvertises (params) {
      this.page.loading = true
      const [, { data: { header, data: { data: { data, total } } } }] = await capturedGet(`/${this.platform}/ads`, this.getRequestParams(params))
      this.page.setData({ header, data, total })
      this.loadings = Array.from({ length: data.length }, Boolean)
    },
    searchAd () {
      this.page.resetData()
      this.currentNav = 'all'
      this.getVerifyList()
      this.getAdvertises()
    },
    handleSelectChange ({ selection, selectAll }) {
      this.selectedIds = selection.map(v => v.id)
    },
    startAndStopAd (row, index) {
      if (row.verify !== '已通过') return this.$message.error('审核未通过，广告不可以投放！')
      if (this.stopStatuses.includes(row.status_msg)) return this.$message.error(`广告状态为“${row.status_msg}”的广告无法开启！`)

      this.batchStartAndStopAd([row.id], false, row.status === 0, index)
    },
    async batchStartAndStopAd (ids, batch, isStart, index) {
      if (batch) {
        if (!ids.length) {
          return this.$message.error(`你还没有选中要批量${isStart ? '开启' : '暂停'}的广告`)
        }
        const selectedData = this.page.data.filter(item => ids.indexOf(item.id) > -1)
        const noverifyData = selectedData.filter(item => item.verify !== '已通过')
        if (noverifyData.length > 0) return this.$message.error('存在审核未通过或已拒绝的广告！')

        if (isStart) {
          const startData = selectedData.filter(item => this.stopStatuses.includes(item.status_msg))
          if (startData.length > 0) return this.$message.error('存在排期已过的广告！')
        }
      }

      let text = isStart ? '开启' : '暂停'
      const status = isStart ? 'starting' : 'stopping'
      if (batch) {
        this[status] = true
        text = '批量' + text
      } else {
        this.loadings.splice(index, 1, true)
      }

      const [err, res] = await capturedPost(`/${this.platform}/ads/${isStart ? 'batchstart' : 'batchstop'}`, { ids })
      if (batch) {
        this[status] = false
      } else {
        this.loadings.splice(index, 1, false)
      }
      if (err || res.code !== 1) this.$message.error(`${text}广告失败！`)
      else {
        this.$message.success(`${text}广告成功！`)
        this.getAdvertises()
      }
    },
    operateAd (type, row) {
      const params = { type, adType: this.adType }
      const query = {}
      if (['view', 'edit', 'copy'].includes(type)) {
        params.id = row.id;
        query.oid = row.order_id
      }
      this.$router.push({ name: 'advertiseOpr', params, query })
    },
    removeAd (row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的广告吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await capturedRemove(`/${this.platform}/ads/${row.id}`)
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) this.$message({ type: 'error', message: '删除广告失败！' })
            else if (res.code === 1) this.$message({ type: 'success', message: '删除广告成功！' })
          }
          done();
        }
      }).then(_ => {
        this.getAdvertises()
      })
    },
    handleCellClick (row, column) {
      if (column.property !== 'verify' || row.verify === '已审核') return
      if (row.verify === '已拒绝') {
        this.refuse.visible = true
        this.refuse.reason = (row.verify_message || '').split(/[\n↵]/g)
        this.refuse.image = row.verify_msg_pic
      }
    }
  },
  created () {
    this.platform = this.$route.meta.platform
    const { name, value } = this.$route.query
    this.key = value
    this.value = name
    this.adType = this.globalAdType

    const items = new Map()
      .set('ad_from', 'adFroms')
      .set('verify', 'verifies')
      .set('status', 'statuses')
    const itemValues = [...items.values()]
    Promise.all(
      [...items.keys()].map(item =>
        get(`/interface/etcd/item/${item}`)
      )
    ).then(results => {
      results.forEach((res, i) => {
        this[itemValues[i]] = res.data
      })
    })

    this.getSearchList()
    this.getAdvertises()
  }
}
</script>

<style lang="scss">
</style>
